import { JSXElement } from "@babel/types";
import { Button, Popover, Typography, useTheme } from "@mui/material";
import { Ico_Bulk } from "@sagecentral/core-ui";
import { ReactNode, useState } from "react";

interface IPupoverBulkUpdate {
    child?: ReactNode
};

const BulkUpdateMenuButton = (props: IPupoverBulkUpdate) => {
    const {child} = props;
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const bulkUpdateOpen = Boolean(anchorEl);


    const handleBulkUpdateClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <>
            <Typography sx={{ display: 'flex', gap: '8px', color: theme.palette.common.black, cursor: 'pointer' }} 
                onClick={handleBulkUpdateClick} 
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        handleBulkUpdateClick(e as unknown as React.MouseEvent<HTMLButtonElement>);
                    }
                }}
                rel="noopener noreferrer" 
                tabIndex={0}
                aria-label="Bulk Update">
                <svg height={24} width={24} viewBox="0 0 22 22" fill="none" >
                    <Ico_Bulk sx={{ stroke: '#001A69' }} />
                </svg> Bulk Update
            </Typography>
            <Popover
                open={bulkUpdateOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}>
                    
                    {child}
            </Popover>
        </>
    )

}

export default BulkUpdateMenuButton;